<template>
    <div class="downcardlistbg">
        <div class="downcardlistbg_title">
            他們也正在關心{{title}}
        </div>
        <div v-if="getwidth" class="downcardlist">
            <bottom_wishercard 
                v-for="data in getdata"
                :key="data.name"
                :site_name="data.site_name"
                :name="data.name"
                :title="data.title"
            />
        </div>
        <swiper v-if="!getwidth" class="swiperscetion" ref="mySwiper" :options="getoption" @slideChange="onSlide">
            <swiper-slide 
                v-for="data in getdata"
                :key="data.name"
            >
                <swiper_wishercard 
                    :site_name="data.site_name"
                    :name="data.name"
                    :title="data.title"
                />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div v-if="!getwidth" class="swiper_left" @click="swipe('left')" v-show="arrowL">
            <img src="https://p3.udn.com.tw/wish/images/bottommenu/botton_slideshow_left.svg" />
        </div>
        <div v-if="!getwidth" class="swiper_right" @click="swipe('right')" v-show="arrowR" >
            <img src="https://p3.udn.com.tw/wish/images/bottommenu/botton_slideshow_right.svg" />
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import cardlistdata from '@/assets/js/data/cardlistdata'
    import bottom_wishercard from '@/components/common/bottom_wishercard.vue'
    import swiper_wishercard from '@/components/common/swiper_wishercard.vue'
    export default {
        components: {
            bottom_wishercard,
            swiper_wishercard,
            Swiper,
            SwiperSlide,
        },
        data(){
            return{
                cardlistdata,
                getdata: [],
                title: "",
                arrowL:false,
                arrowR:true,
                // getoption:{
                //     vspeed: 1000,
                // }
            }
        },
        props: {

        },
        computed:{
            getwidth(){
                if(navigator.userAgent.match(/iPhone/i) || window.innerWidth<768) return false;
                return true;
            },
            getoption(){
                if(window.innerWidth>=600){
                    return {
                        slidesPerView: 1.7,
                        spaceBetween: 10,
                        centeredSlides: true,
                        pagination: {
                            el: '.swiper-pagination'
                        }
                    }
                }
                else if(window.innerWidth>=350){
                    return {
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                        centeredSlides: true,
                        pagination: {
                            el: '.swiper-pagination'
                        }
                    }
                }
                else if(window.innerWidth>=300){
                    return {
                        slidesPerView: 1.35,
                        spaceBetween: 10,
                        centeredSlides: true,
                        pagination: {
                            el: '.swiper-pagination'
                        }
                    }
                }
                else{
                    return {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                        centeredSlides: true,
                        pagination: {
                            el: '.swiper-pagination'
                        }
                    }
                }
            }
        },
        mounted(){
            this.cardlistdata.forEach(element => {
                element['cardinfo'].forEach(cell => {
                    if(cell["site_name"]==this.$store.state.currentwisher){
                        this.getdata=element['cardinfo'];
                        this.title=element['title'];
                    }
                })
            });
        },
        methods:{
            onSlide(){
                let nowIndex = this.$refs.mySwiper.$swiper.activeIndex;
                let swaperLenght = this.$refs.mySwiper.$children.length;
                if(nowIndex == 0) {
                    this.arrowR = true;
                    this.arrowL =false;
                }else{
                    this.arrowR = true;
                    this.arrowL =true;
                }
                if(nowIndex+1 == swaperLenght){
                    this.arrowR = false;
                    this.arrowL =true;
                }

            },
            swipe(para){
                if(para=="left") this.$refs.mySwiper.$swiper.slideTo(this.$refs.mySwiper.$swiper.activeIndex-1);
                else this.$refs.mySwiper.$swiper.slideTo(this.$refs.mySwiper.$swiper.activeIndex+1);
            }
        },
    }
</script>

<style lang="scss" scoped>
.downcardlistbg{
    position: relative;
    width: 100%;
    margin: auto;
    background-color: #FAFAFA;
    @media (min-width: 768px) AND (max-width: 960px) {
        width: 600px;
    }
    @media (min-width: 960px) AND (max-width: 1050px) {
        width: 900px;
    }
    @media (min-width: 1050px) {
        width: 1050px;
    }
    .downcardlistbg_title{
        position: relative;
        text-align: center;
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 40px;
        margin-top: 60px;
        color: #1D1C1B;
        font-family: 'Noto Serif TC';
        font-weight: bold;
        @media (min-width: 768px) {
            font-size: 30px;
            line-height: 40px;
            margin-top: 80px;
            margin-bottom: 60px;
        }
    }
    .downcardlist{
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 135px;
        @media (min-width: 960px) AND (max-width: 1050px) {
            margin-bottom: 130px;
        }
        @media (min-width: 1050px) {
            margin-bottom: 150px;
        }
    }
    .swiperscetion{
        position: relative;
        width: 100%;
        margin-bottom: 100px;
    }
    .swiper_left{
        position: absolute;
        z-index: 20;
        top: calc( 50% - 60px );
        left: -10px;
        cursor: pointer;
        @media (min-width: 400px) {
            left: 0;
        }
    }
    .swiper_right{
        position: absolute;
        z-index: 20;
        top: calc( 50% - 60px );
        right: -10px;
        cursor: pointer;
        @media (min-width: 400px) {
            right: 0;
        }
    }
}
</style>